export const LOW_PRIORITY = 'Low'
export const URGENT_PRIORITY = 'Urgent'
export const SUGGESTED_PRIORITY = 'Med'
